// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import './styles.scss';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import validator from 'validator';
import InputField from 'components/commonComponents/InputField';
import Button from 'components/commonComponents/Button';

// icons

import TextArea from 'components/commonComponents/TextArea';

import ReCAPTCHA from "react-google-recaptcha";
import { APP_ID, RECAPTCHA } from 'config/constants';
import { Alert } from 'antd';
import { Fade } from 'react-reveal';

const Contact = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [error, setError] = useState('');
    const [errorAlert, setErrorAlert] = useState({ msg: '', open: false, severity: '' })
    const { name, email = '', phone, message, captcha } = data;

    const handleOnChange = (key) => (value) => {
        setError({
            ...error,
            [key]: null
        });
        setData({
            ...data,
            [key]: value
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handleSubmit = async () => {
        const errors = {
            name: !name && 'Enter the name',
            email: !email && 'Enter valid email' || !validator.isEmail(email) && 'Enter valid email',
            phone: !phone && 'Enter valid phone' || !validator.isNumeric(phone) && 'Enter valid phone',
            message: !message && 'Enter the message',
            captcha: !captcha
        };
        setError(errors);
        let isFormValid = Object.values(errors).every((item) => !item);
        if (!isFormValid) return;
        setLoading(true);
        const formData = new FormData();
        formData.append('action', 'contact');
        formData.append('appId', APP_ID);
        formData.append('name', name);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('feedback', message);
        const res = await fetchData(restAPIs.contactUs(formData));
        if (res?.statusCode === 200) {
            console.log("hh2");
            setData({})
            setError({})
            setErrorAlert(prevState => ({
                ...prevState,
                msg: 'Your message has been sent successfully',
                open: true,
                severity: 'success'
              }))
            setTimeout(() => {
                setErrorAlert(prevState => ({
                    ...prevState,
                    msg: '',
                    open: false,
                    severity: ''
                  }))
            }, 3000);
        }
        else {
            setErrorAlert(prevState => ({
                ...prevState,
                msg: res.errormessage,
                open: true,
                severity: 'error'
              }))
            setTimeout(() => {
                setErrorAlert(prevState => ({
                    ...prevState,
                    msg: '',
                    open: false,
                    severity: ''
                  }))
            }, 3000);
        }
        setLoading(false);

    }

    const onChange = (value) => {
        setError({
            ...error,
            captcha: null
        });
        setData({
            ...data,
            captcha: value
        });
    }

    const socialIcons = {
        Facebook: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path fill="#222222" d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" /></svg>,
        Twitter: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#222222" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>,
        YouTube: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><path fill="#222222" d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg>,
        Instagram: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path fill="#222222" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>,
        Blogspot: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path fill="#222222" d="M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"/></svg>,
        Pinterest: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="15.5" viewBox="0 0 496 512"><path fill="#222222" d="M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3 .8-3.4 5-20.3 6.9-28.1 .6-2.5 .3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"/></svg>,
        LinkedIn: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path fill="#222222" d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg>,
        Soundcloud: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512"><path fill="#222222" d="M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2 .8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1 .6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7 .6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3 .1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"/></svg>
      }


    return (

        <>
            <Fade bottom >
                <div className='container __articles_list' style={{ paddingTop: '20vh', paddingBottom: '6%' }}>
                    <div className='inner'>
                        <div className="c-heading text-center">
                            {/* <div className="c-heading__top">
                    <h2 className="text-default"> Profile</h2>
                </div> */}
                            <div className="c-heading__middle">
                                <h3 className="heading-3 text-uppercase">{t('contact_us')}</h3>
                            </div>
                        </div>
                    </div>
                    <div className='block mt-5'>
                        <div className='inner'>
                            <div className='row justify-content-between'>
                                <div className='col-md-7'>
                                    <div className='row mb-5'>
                                        <Fade bottom cascade>
                                            <div className='mb-4'>
                                                <InputField
                                                    type="text"
                                                    placeholder={t('name')}
                                                    value={name}
                                                    onChange={handleOnChange('name')}
                                                    error={error.name}
                                                />
                                            </div>
                                        </Fade>
                                        <Fade bottom cascade>
                                            <div className='mb-4'>
                                                <InputField
                                                    type="email"
                                                    placeholder={t('email')}
                                                    value={email}
                                                    onChange={handleOnChange('email')}
                                                    error={error.email}
                                                />
                                            </div>
                                        </Fade>
                                        <Fade bottom cascade>
                                            <div className='mb-4'>
                                                <InputField
                                                    type="number"
                                                    placeholder={t('phone')}
                                                    value={phone}
                                                    onChange={handleOnChange('phone')}
                                                    error={error.phone}
                                                />
                                            </div>
                                        </Fade>
                                        <Fade bottom cascade>
                                            <div className='mb-4'>
                                                <TextArea
                                                    type="text"
                                                    placeholder={t('message')}
                                                    value={message}
                                                    onChange={handleOnChange('message')}
                                                    height={250}
                                                    error={error.message}
                                                />
                                            </div>
                                        </Fade>
                                        <Fade bottom cascade>
                                            <div className='mb-4'>
                                                <p><ReCAPTCHA
                                                    sitekey={RECAPTCHA}
                                                    onChange={onChange}
                                                /></p>
                                                <p style={{ color: '#e35061', fontSize: '14px', fontWeight: '300', marginLeft: '20px' }}>{error.captcha ? 'Verify captcha' : ''}</p>
                                            </div>
                                        </Fade>
                                        <Fade bottom cascade>
                                            <div className='mb-5 mt-4 text-center'>
                                                <Button
                                                    label={t('submit')}
                                                    handleOnClick={handleSubmit}
                                                    withLoader
                                                    loading={isLoading}
                                                    disabled={isLoading}
                                                />
                                            </div>
                                        </Fade>
                                    </div>
                                    {errorAlert && errorAlert.open ?
                                        <Alert showIcon type={errorAlert.severity} message={errorAlert.msg} />: ''}
                                </div>
                                <div className='col-md-4 __address'>
                                <address>
                                        <ul>
                                            <li className='mb-2'><strong>VILLAGE ELECTRONICS<br/>SOLE PROPRIETORSHIP L.L.C.</strong></li>
                                            <li>Post Box : 33291</li>
                                            <li>Abudhabi, UAE</li>
                                            <li>Tel : 026216484 / 026344029 / 050-2205597</li>
                                            {/* <li><a href="tel:+917994884447">(+91) 7994-884-447</a></li> */}
                                        </ul>
                                        <ul>
                                            <li className='mb-2'><strong>Emerald Agencies and Computers LLC</strong></li>
                                            <li>Post Box : 33291</li>
                                            <li>Abudhabi, UAE</li>
                                            <li>Tel : 026216484 / 026344029 </li>
                                        </ul>
                                        <ul>
                                            <li>Email : <b><a href="mailto:info@electronicvillage.org">info@electronicvillage.org</a></b></li>
                                        </ul>
                                        <ul className="__social__nav">
                                            <li><a href="https://www.facebook.com/mohammed.suwaidi.poet/" target="_blank">{socialIcons?.Facebook}</a></li>
                                            <li><a href="https://www.twitter.com/mohamedsuwaidi5/" target="_blank">{socialIcons?.Twitter}</a></li>
                                            <li><a href="https://www.youtube.com/mohammedsuwaidi5/" target="_blank">{socialIcons?.YouTube}</a></li>
                                            <li><a href="https://www.instagram.com/mohammed.al.suwaidi/" target="_blank">{socialIcons?.Instagram}</a></li>
                                            <li><a href="https://mohammedsuwaidi.blogspot.ae/" target="_blank">{socialIcons?.Blogspot}</a></li>
                                            <li><a href="https://www.pinterest.com/mohammedsuwaidi5/" target="_blank">{socialIcons?.Pinterest}</a></li>
                                            <li><a href="https://www.linkedin.com/in/mohammedsuwadi/" target="_blank">{socialIcons?.LinkedIn}</a></li>
                                            <li><a href="https://soundcloud.com/his-excellency-mohammed-ahmed-al-suwaidi" target="_blank">{socialIcons?.Soundcloud}</a></li>
                                        </ul>
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Fade>
        </>
    );
};

export default Contact;
